// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubjectModal_wrapper__EK99c","west":"SubjectModal_west__j1dD0","active":"SubjectModal_active__AsTGD","spin":"SubjectModal_spin__MYc9q","east":"SubjectModal_east__3OKHq"};